module.exports = __webpack_public_path__ + "static/media/selling.71a9da09.png";